export const menuItems = [
  {
    id: "system-default",
    label: "system-defaults.text",
    isTitle: true,
  },

  {
    id: "1.1",
    label: "system-defaults.template-management.text",
    icon: "bx-receipt",
    link: "/management/template-edit",
  },

  {
    id: 1,
    label: "common.library",
    isTitle: true,
  },
  {
    id: "roadmap",
    label: "roadmap.text",
    icon: "mdi mdi-map-marker-distance",
    subItems: [
      {
        id: "platform-roadmap",
        label: "roadmap.platform.text",
        link: "/management/roadmap/platform",
      },
      {
        id: "gdpr-roadmap",
        label: "roadmap.gdpr.text",
        link: "/management/roadmap/gdpr",
      },
      {
        id: "kvkk-roadmap",
        label: "roadmap.kvkk.text",
        link: "/management/roadmap/kvkk",
      },
      {
        id: "bgys-roadmap",
        label: "roadmap.bgys.text",
        link: "/management/roadmap/bgys",
      },
      {
        id: "ddo-roadmap",
        label: "roadmap.ddo.text",
        link: "/management/roadmap/ddo",
      },
    ],
  },
  {
    id: "system-flow",
    label: "system-flow.text",
    icon: "mdi mdi-beaker-question",
    link: "/management/system-flow",
  },

  {
    id: 2,
    label: "common.library",
    icon: "mdi mdi-database",
    subItems: [
      // BEGIN : Entity Pages
      {
        id: "sector",
        label: "sector.text",
        icon: "mdi mdi-alpha-s-circle",
        link: "/management/sector",
      },
      {
        id: "unit",
        label: "unit.text",
        icon: "mdi mdi-office-building",
        link: "/management/unit",
      },

      {
        id: 2.5,
        parentId: 2,
        label: "asset-group.text",
        icon: "bx-git-repo-forked",
        subItems: [
          {
            id: 3,
            label: "asset-group-category.text",
            link: "/management/asset-group-category",
            parentId: 2.5,
          },
          {
            id: 4,
            label: "asset-group.text",
            link: "/management/asset-group",
            parentId: 2.5,
          },
        ],
      },

      {
        id: 2.5,
        parentId: 2,
        label: "data.text",
        icon: "bx-git-repo-forked",
        subItems: [
          {
            id: 3,
            label: "data.text",
            link: "/management/data",
            parentId: 2.5,
          },
          {
            id: 4,
            label: "data-category.text",
            link: "/management/data-category",
            parentId: 2.5,
          },
        ],
      },
      {
        id: "datasubject-parent",
        parentId: 2,
        label: "datasubject.text",
        icon: "bx-git-repo-forked",
        subItems: [
          {
            id: "datasubject",
            label: "datasubject.text",
            link: "/management/datasubject",
            parentId: "datasubject-parent",
          },
          {
            id: "datasubject-category",
            label: "datasubject-category.text",
            link: "/management/datasubject-category",
            parentId: "datasubject-parent",
          },
          {
            id: "datasubject-right",
            label: "datasubject-right.text",
            link: "/management/datasubject-right",
            parentId: "datasubject-parent",
          },
        ],
      },
      {
        id: "data-breach",
        label: "data-breach.text",
        subItems: [
          {
            id: "abroad-third-party",
            label: "abroad-third-party.text",
            link: "/management/abroad-third-party",
          },
          {
            id: "domestic-third-party",
            label: "domestic-third-party.text",
            link: "/management/domestic-third-party",
          },
          {
            id: "notification-type",
            label: "notification-type.text",
            link: "/management/notification-type",
          },
          {
            id: "possible-effect",
            label: "possible-effect.text",
            link: "/management/possible-effect",
          },
          {
            id: "processing-adjective",
            label: "processing-adjective.text",
            link: "/management/processing-adjective",
          },
          {
            id: "source-and-type",
            label: "source-and-type.text",
            link: "/management/source-and-type",
          },
        ],
      },
      {
        id: "processing-transfering",
        label: "processing-transfering.text",
        subItems: [
          {
            id: "purpose",
            label: "processing-transfering.purpose.text",
            link: "/management/purpose",
            parentId: "processing-transfering",
          },
          {
            id: "legal-reason",
            label: "processing-transfering.legal-reason.text",
            link: "/management/legal-reason",
            parentId: "processing-transfering",
          },
          {
            id: "legitimate-interest",
            label: "processing-transfering.legitimate-interest.text",
            link: "/management/legitimate-interest",
            parentId: "processing-transfering",
          },
        ],
      },
      {
        id: 2.2,
        parentId: 2,
        label: "department.text",
        subItems: [
          {
            id: 5,
            label: "department.text",
            link: "/management/department",
            parentId: 2.2,
          },
          {
            id: 6,
            label: "department-category.text",
            link: "/management/department-category",
            parentId: 2.2,
          },
        ],
      },
      {
        id: 2.3,
        label: "process.text",
        subItems: [
          {
            id: 6,
            label: "process.text",
            link: "/management/process",
            parentId: 2.3,
          },
          {
            id: 7,
            label: "process-category.text",
            link: "/management/process-category",
            parentId: 2.3,
          },
        ],
      },
      {
        id: 2.4,
        label: "datasource.text",
        subItems: [
          {
            id: 8,
            label: "datasource.text",
            link: "/management/data-source",
          },
        ],
      },
      {
        id: 2.6,
        label: "storage-environments.text",
        subItems: [
          {
            id: 11,
            label: "physical-storage.text",
            link: "/management/physical-storage",
          },
          {
            id: 12,
            label: "physical-storage-category.text",
            link: "/management/physical-storage-category",
          },
          {
            id: 9,
            label: "electronic-storage.text",
            link: "/management/electronic-storage",
          },
          {
            id: 10,
            label: "electronic-storage-category.text",
            link: "/management/electronic-storage-category",
          },
          {
            id: 13,
            label: "disposal-method.text",
            link: "/management/disposal-method",
          },
        ],
      },
      {
        id: 2.99,
        label: "archive-environments.text",
        subItems: [
          {
            id: 14,
            label: "physical-archive.text",
            link: "/management/physical-archive",
          },
          {
            id: 15,
            label: "physical-archive-category.text",
            link: "/management/physical-archive-category",
          },
          {
            id: 16,
            label: "electronic-archive.text",
            link: "/management/electronic-archive",
          },
          {
            id: 17,
            label: "electronic-archive-category.text",
            link: "/management/electronic-archive-category",
          },
        ],
      },
      {
        id: 2.7,
        label: "accessing-persons.text",
        subItems: [
          {
            id: 12,
            label: "accessing-persons.text",
            link: "/management/accessor",
          },
        ],
      },
      {
        id: "access-restriction",
        label: "access-restriction.text",
        subItems: [
          {
            id: 101,
            label: "access-restriction.text",
            link: "/management/access-restriction",
          },
        ],
      },
      {
        id: "policy-parent",
        label: "policy.text",
        subItems: [
          {
            id: "policy",
            label: "policy.text",
            link: "/management/policy",
          },
          {
            id: "policy-group",
            label: "policy-group.text",
            link: "/management/policy-group",
          },
        ],
      },
      {
        id: 2.5,
        label: "collect-method.text",
        subItems: [
          {
            id: 102,
            label: "direct-collect-method.text",
            link: "/management/direct-collect-method",
            parentId: 2.5,
          },
          {
            id: 2,
            label: "other-collect-method.text",
            link: "/management/other-collect-method",
            parentId: 2.5,
          },
        ],
      },
      {
        id: 2.9,
        label: "receiver-group.text",
        subItems: [
          {
            id: 103,
            label: "receiver-group.text",
            link: "/management/receiver-group",
          },
        ],
      },
      {
        id: "transfering",
        label: "transfering.text",
        subItems: [
          {
            id: "transfering-method",
            label: "transfering.method.text",
            link: "/management/transfering-method",
            parentId: "transfering",
          },
          {
            id: "transfering-prevention",
            label: "transfering.prevention.text",
            link: "/management/transfering-prevention",
            parentId: "transfering",
          },
        ],
      },
      {
        id: 2.6,
        label: "agreement-type.text",
        subItems: [
          {
            id: 104,
            label: "agreement-type.text",
            link: "/management/agreement-type",
          },
        ],
      },
      {
        id: "risk",
        label: "risk.text",
        subItems: [
          {
            id: "risk-definition",
            label: "risk.definition.text",
            link: "/management/risk-definition",
          },
          {
            id: "risk-threat-definition",
            label: "risk.threat-definition.text",
            link: "/management/risk-threat-definition",
          },
          {
            id: "risk-weakness-definition",
            label: "risk.weakness-definition.text",
            link: "/management/risk-weakness-definition",
          },
          {
            id: "risk-applied-control",
            label: "risk.applied-control.text",
            link: "/management/risk-applied-control",
          },
        ],
      },
      {
        id: "question-set",
        label: "question-set.plural",
        subItems: [
          {
            id: "question-set",
            label: "question-set.plural",
            link: "/management/question-set",
          },
          {
            id: "question",
            label: "question.text",
            link: "/management/question",
          },
        ],
      },
      {
        id: "tasks",
        label: "task-menu.text",
        subItems: [
          {
            id: "task-category",
            label: "task-menu.task-category.text",
            link: "/management/task-category",
          },
        ],
      },

      {
        id: "application",
        parentId: 2,
        label: "application.text",
        subItems: [
          {
            id: 3,
            label: "application.category.text",
            link: "/management/application-category",
            parentId: "application",
          },
        ],
      },
      {
        id: "country",
        parentId: 2,
        label: "country.text",
        subItems: [
          {
            id: 3,
            label: "country.country-safe-mapping.text",
            link: "/management/library/safe-country-map",
            parentId: "country",
          },
        ],
      },
      {
        id: "legal-document-template",
        label: "legal-document-template.text",
        subItems: [
          {
            id: "legal-document-template",
            label: "legal-document-template.text",
            link: "/management/legal-document-template",
          },
          {
            id: "legal-document-template-category",
            label: "legal-document-template-category.text",
            link: "/management/legal-document-template-category",
          },
        ],
      },
      {
        id: "report-template",
        label: "report-template.text",
        subItems: [
          {
            id: "report-template",
            label: "report-template.text",
            link: "/management/report-template",
          },
        ],
      },
      // END : Entity Pages
    ],
  },

  {
    id: 6,
    isLayout: true,
  },
  {
    id: 7,
    label: "account.text",
    isTitle: true,
  },

  {
    id: "app-panel",
    label: "common.panel",
    icon: "bx-user",
    link: "/management/account-workspace-organization",
  },

  {
    id: "role-management",
    label: "role.plural",
    icon: "bx-shield-quarter",
    link: "/management/role",
  },

  {
    id: "role-access-management",
    label: "role.access.text",
    icon: "bx-shield-quarter",
    link: "/management/role-access",
  },
  {
    id: 105,
    label: "common.system",
    isTitle: true,
  },
  {
    id: "log",
    label: "log.text",
    icon: "bx-code",
    link: "/management/log",
  },
  {
    id: "mail-log",
    label: "log.mail.text",
    icon: "mdi mdi-email-check-outline",
    link: "/management/mail-log",
  },

  {
    id: "transfer-library",
    label: "transfer.library-text",
    icon: "bx bx-transfer-alt",
    link: "/management/transfer-library",
  },
  {
    id: "announcement",
    label: "announcement.plural",
    icon: "bx bxs-megaphone",
    link: "/management/announcement",
  },
  {
    id: "config",
    label: "config.text",
    icon: "bx bx-cog",
    link: "/management/config",
  },
];
